import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class ShelfService {
  private apiUrl = '/shelves';
  private apiSpringUrl = '/spring/shelves';

  constructor(private http: HttpService) { }

  get(params?: any): Promise<any> {
    let url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}`;
    if (params != undefined) {
      url = `${url}?${params}`
    }
    return this.http.get(url);
  }

  post(
    shelfCd: string,
    shelfTx: string,
    updprogramCd: string
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl;

    const jsonInput = {
      shelfCd: shelfCd,
      shelfTx: shelfTx,
      updprogramCd: updprogramCd
    };

    return this.http.post(url, jsonInput);

  }

  put(
    shelfCd: string,
    shelfTx: string,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${shelfCd}`;

    const jsonInput = {
      shelfCd: shelfCd,
      shelfTx: shelfTx,
      updprogramCd: updprogramCd
    };

    return this.http.put(url, jsonInput);
  }

  delete(shelfCd: string): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${shelfCd}`;
    return this.http.delete(url);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/shelf/shelf.service.ts